<div class="noUi-pips noUi-pips-horizontal">
  <mat-slider
    [style.width.%]="100"
    [min]="min"
    [max]="max"
    [step]="step"
    [value]="value"
    [thumbLabel]="thumbLabel"
    [tickInterval]="tickInterval"
    (change)="onValueChange($event)"
  ></mat-slider>
<div class="pdd-10">
  <ng-container *ngFor="let pip of pips">
    <div
      class="noUi-marker noUi-marker-horizontal"
      [ngClass]="{
        'noUi-marker-large': pip.isMajor,
        'noUi-marker-normal': !pip.isMajor
      }"
      [style.left.%]="pip.position"
    ></div>

    <div
      *ngIf="pip.isMajor"
      class="noUi-value noUi-value-horizontal noUi-value-large"
      [attr.data-value]="pip.value"
      [style.left.%]="pip.position"
    >
      {{ pip.value }}
    </div>
  </ng-container>
</div>
</div>
